import React from "react";

import { Container, Title, Description } from "./styles";

export default class PrivacyContainer extends React.Component {
  render() {
    return (
      <Container className={"privacy"}>
        <Title>Privacy Policy</Title>
        <Description>
          <p>
            This Privacy Policy was last updated and effective as of 2/23/18. This Privacy Policy applies only
            to{" "}
            <a style={{ color: "#FF3600", textDecoration: "none" }} href="https://bobcatonlinetraining.com/">
              bobcatonlinetraining.com
            </a>
          </p>
          <p>
            Welcome to the Privacy Policy for the Bobcat Company (“we” or “us” or “Bobcat”) website located at{" "}
            <a style={{ color: "#FF3600", textDecoration: "none" }} href="https://bobcatonlinetraining.com/">
              bobcatonlinetraining.com
            </a>
            . We appreciate your interest in this website and other linked sites. This Privacy Policy
            describes how we may collect, use, share and keep information we get about you.
          </p>

          <h2>General Disclaimer and Updates to this Privacy Policy</h2>

          <p>
            We take the privacy of your personal information very seriously. While you visit this website, we
            will not collect any personal information about you unless you choose to provide that information.
            Any personal information collected will only be used in accordance with this Privacy Policy.
            Please review this entire Privacy Policy carefully. We remind you that if you visit a link outside
            of bobcatonlinetraining.com, then you are subject to the Privacy Policies of that other website,
            and Bobcat has no control over the information that may be collected from you by another website.
          </p>
          <p>
            We may revise this Privacy Policy over time. If we make material changes, the changes will only be
            posted on this website and we will update the “effective date” at the top of this page. Please
            check bobcatonlinetraining.com from time to time for the most current version of our Privacy
            Policy.
          </p>

          <h2>Information Collected and Stored Automatically</h2>

          <p>
            Bobcat’s web servers automatically collect usage information from you when you visit
            bobcatonlinetraining.com. Website usage information informs us about how our visitors use and
            navigate this website. This information helps us give you the best possible experience. For each
            page that you visit on bobcatonlinetraining.com, we may collect and store the following
            information:
          </p>

          <ul>
            <li>the number of visits, including the date and time of access to bobcatonlinetraining.com;</li>
            <li>the URL address of the bobcatonlinetraining.com web page visited;</li>
            <li>the length of time you stay on a web page;</li>
            <li>your Internet Protocol (IP) address;</li>
            <li>name and contact information, including email address;</li>
            <li>demographic information such as postcode, preferences and interests; and</li>
            <li>other information relevant to customer surveys and/or offers.</li>
          </ul>

          <p>
            This data informs us about the number of visitors to this website and the type of technology our
            visitors use.
          </p>

          <p>
            Additionally, certain pages of this website may use cookies and clear graphics interchange format
            images (“GIFs”) to track and store your information for the purposes described in this Privacy
            Policy. This allows us to recognize you as a registered user if you return to
            bobcatonlinetraining.com using the same computer and browser.
          </p>
          <p>
            A “cookie” is a tiny element of data that this website can send to your browser, which may then be
            stored on your hard drive so that the Bobcat server can recognize you when you return. Websites
            use cookies to track activities (such as pages visited, links clicked) so that more customized
            features can be provided when the website user returns. Instructions on how to erase cookies or
            block this information from your computer is provided at the link below.
          </p>
          <p>
            We use Google Analytics, a web analytics service provided by Google, Inc. (“Google”). Google
            Analytics uses cookies to help us analyze how you use bobcatonlinetraining.com. The information
            generated by the cookie about your use of this website (including your IP address) will be
            transmitted to and stored by Google on servers owned by Google. Google will use this information
            for the purpose of evaluating use of bobcatonlinetraining.com, compiling reports on website
            activity for website operators, and providing other services relating to website activity and
            Internet usage. Google may also transfer this information to third parties where required to do so
            by law, or where such third parties process the information on Google’s behalf. You may refuse the
            use of cookies by selecting the appropriate settings on Google’s browser. To find out more
            information about Google Analytics, including information about its Privacy Policy, please visit{" "}
            <a
              style={{ color: "#FF3600", textDecoration: "none" }}
              href="https://support.google.com/analytics/answer/6004245?hl=en/">
              https://support.google.com/analytics/answer/6004245?hl=en/
            </a>
            . To learn more about how to disable cookies in your browser, please visit{" "}
            <a
              style={{ color: "#FF3600", textDecoration: "none" }}
              href="https://www.usa.gov/optout-instructions.shtml">
              https://www.usa.gov/optout-instructions.shtml
            </a>
            .
          </p>

          <h2>Information Collected From You</h2>

          <p>
            On the bobcatonlinetraining.com website, you may be asked to voluntarily submit personal
            information such as your first and last name, company name, email address, phone number, fax
            number and address. This may occur if you intend to access certain areas of the
            bobcatonlinetraining.com website. You may also be asked to establish a login name and password in
            order to access certain areas of bobcatonlinetraining.com. If you forget your password, you may
            request to reset your password. In these cases, all information voluntarily submitted by you is
            retained by us and is used only for the express purpose for which it is provided and in accordance
            with this Privacy Policy.
          </p>

          <h2>Your Ability to Choose</h2>

          <p>
            The information collected from you helps us communicate with you to provide information, products
            and services that you have requested. It is your choice to send us these requests. Through your
            Internet browser, you may have the option to reject this website’s cookies and still use this
            website. You may always opt out of receiving marketing emails by following the instructions on the
            marketing email that you receive from us.
          </p>

          <h2>How We Use and Share Your Information</h2>

          <p>
            We may combine the personal information that you provide us with other information about you that
            is available to us, including information from other sources (e.g. offline data or data obtained
            from third parties). The ways that we may use your information include:
          </p>

          <ul>
            <li>to respond to your specific inquiries;</li>
            <li>to troubleshoot any issues with respect to your use of bobcatonlinetraining.com;</li>
            <li>
              to provide you with information on products and services, either on a personalized or aggregate
              basis; and
            </li>
            <li>
              to give bobcatonlinetraining.com editors anonymous, aggregate information that is useful for
              developing new features and products for our visitors and to improve the content and navigation
              on bobcatonlinetraining.com.
            </li>
          </ul>

          <p>
            We may share your personal information with trusted third parties such as dealers, our third-party
            website developer and internal marketing administrators for the purposes described in this Privacy
            Policy.
          </p>

          <p>
            We may also disclose information to respond to legal requirements or requests, enforce our
            policies and protect the rights, property and safety of Bobcat. Such information will be disclosed
            in accordance with applicable laws and regulations.
          </p>

          <p>
            We will disclose information to law enforcement, governmental agencies or third parties authorized
            by law, in response to a verified request relating to a criminal investigation or alleged illegal
            activity or any other activity that may expose us, you or any other website user to legal
            liability. We may disclose your personal information, any communications sent or received by you,
            and any other information that we may have about you to prevent, investigate and identify persons
            or organizations potentially involved in activity that appears to us to be illegal, or that we
            believe may expose us to legal liability. Additionally, we may disclose personal information in
            situations that we believe to be emergencies involving potential threats to the physical safety of
            any person or property if we believe that the information in any way relates to that threat. In
            such events, we will disclose any information that is relevant and necessary to the investigation
            or to prevent injury or illegal activity.
          </p>

          <p>
            In the event we are engaged in or contemplating a merger or other corporate acquisition with
            another business entity, personal information may be disclosed to and would likely be acquired by
            the other business entity.
          </p>
          <h2>Children</h2>
          <p>
            We care about the safety and privacy of children online, and we comply with the Children’s Online
            Privacy Protection Act of 1998 (“COPPA”). COPPA and its accompanying regulations protect the
            privacy of children using the Internet. This website is directed towards adults and we do not
            knowingly contact, market online to or solicit information of any kind from children under the age
            of 13.
          </p>
          <p>Bobcat does not:</p>

          <ul>
            <li>knowingly collect, use or disclose information from children under the age of 13;</li>
            <li>
              have actual knowledge that it is collecting, using or disclosing personal information from
              children under 13; or
            </li>
            <li>
              have actual knowledge that it is collecting personal information directly from users of another
              website or online service directed to children under the age of 13.
            </li>
          </ul>
          <p>
            If we are notified that information pertaining to a child under 13 was collected unintentionally
            or by fraud or by deception, then as soon as we verify the information, we will immediately obtain
            parental consent or otherwise delete the information from our servers. If you want to notify us of
            our receipt of information by a child under the age of 13, then please do so by sending an e-mail
            to{" "}
            <a style={{ color: "#FF3600", textDecoration: "none" }} href="mailto:ecomcustomercare@bobcat.com">
              ecomcustomercare@bobcat.com
            </a>
            .
          </p>

          <h2>Safeguarding Your Information</h2>

          <p>
            We utilize reasonable security measures designed to secure your information. For instance, your
            personal information is stored on servers that are password- and firewall-protected. Access to
            this information is limited to those employees and independent contractors with a need to know and
            only for the purposes identified in this Privacy Policy. We maintain safeguards intended to
            protect the security, integrity and privacy of these servers and of your personal information.
            While we have implemented reasonable security measures to safeguard personal information, please
            keep in mind that “perfect security” does not exist on the Internet.
          </p>

          <p>
            You are responsible for keeping your login name and password confidential and are responsible for
            all actions taken with your login name and password. If you believe that your password has been
            compromised for any reason, then you should immediately{" "}
            <a style={{ color: "#FF3600", textDecoration: "none" }} href="/contact-us">
              contact us
            </a>{" "}
            and change your password.
          </p>

          <p>
            Some of the pages on <a>bobcatonlinetraining.com</a> use security measures to protect against the
            loss, misuse or alteration of information under our control. When credit card information or other
            sensitive information is transmitted we use Secure Socket Layer (“SSL”) encryption.
          </p>

          <h2>Third-Party Links</h2>

          <p>
            We use some social media tools and websites to interact with our customers. There may be links to
            these other websites on bobcatonlinetraining.com. For example, we allow you to link to Facebook,
            Twitter and various other social media sites from this website. We have no control over these
            linked websites, and they each have separate privacy and data collection practices that are
            independent of Bobcat. Some of these privacy policies are listed below:
          </p>
          <ul>
            <li>
              Facebook:{" "}
              <a
                style={{ color: "#FF3600", textDecoration: "none" }}
                href="https://www.facebook.com/legal/FB_Work_Privacy">
                https://www.facebook.com/legal/FB_Work_Privacy
              </a>
            </li>
            <li>
              Twitter:{" "}
              <a style={{ color: "#FF3600", textDecoration: "none" }} href="https://twitter.com/en/privacy">
                https://twitter.com/en/privacy
              </a>
            </li>
            <li>
              YouTube:{" "}
              <a
                style={{ color: "#FF3600", textDecoration: "none" }}
                href="https://www.google.com/intl/en/policies/privacy/">
                https://www.google.com/intl/en/policies/privacy/
              </a>
            </li>
          </ul>
          <p>
            When you follow a link to another site, you leave bobcatonlinetraining.com and your interactions
            are no longer protected by bobcatonlinetraining.com’s Privacy Policy. We do not endorse the
            privacy or security practices of other websites. Our Privacy Policy does not cover the information
            practices of other companies and organizations.
          </p>
          <p>
            Additionally, certain social media websites and other websites may track your browsing activity
            across this website as well as across other sites that you visit. We strongly encourage you to
            read the policies of any third-party website when deciding whether or not to use it.
          </p>
          <p>
            Bobcat has procedures to help you make sure that your information is accurate, current and
            complete. If you desire to correct any such information or if you have any questions or comments
            regarding this Privacy Policy, please{" "}
            <a style={{ color: "#FF3600", textDecoration: "none" }} href="/help-center">
              contact us
            </a>
            .
          </p>

          <p>© 2023 Bobcat Company. All Rights Reserved.</p>
        </Description>
      </Container>
    );
  }
}
